import { render, staticRenderFns } from "./DialogAddChatMembersAll.vue?vue&type=template&id=988c2958&scoped=true&"
import script from "./DialogAddChatMembersAll.vue?vue&type=script&lang=ts&"
export * from "./DialogAddChatMembersAll.vue?vue&type=script&lang=ts&"
import style0 from "./DialogAddChatMembersAll.vue?vue&type=style&index=0&id=988c2958&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988c2958",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VWindow } from 'vuetify/lib/components/VWindow';
import { VWindowItem } from 'vuetify/lib/components/VWindow';
installComponents(component, {VBtn,VCol,VRow,VSnackbar,VTab,VTabItem,VTabs,VTextField,VWindow,VWindowItem})
